module.exports = __webpack_public_path__ + "static/hubspot-cta-bfc3c66457ab4be2fa00a8a4f05f0e8c.png";